export const errorMessages = (t) => ({
  inputField: t("Field is required"),
  selectField: t("Field is required"),
  emailField: t("Email address is not valid"),
  tooLong: (length) => `The max length of the field is ${length} characters`,
  tooShort: (length) => `The min length of the field is ${length} characters`,
  equals: (length) => `The field must be ${length} characters`,
});
